module.exports = __webpack_public_path__ + "static/img/w.419f54d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/w.svg
// module id = Xxoy
// module chunks = 1